// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bolt-list-drop-indicator-circle {
  background-color: rgba( 43, 136, 216 ,  1 );
  background-color: rgba( var(--palette-primary-tint-10,43, 136, 216) ,  1 );
  border-radius: 50%;
  height: 9px;
  width: 9px;
}
.bolt-list-drop-indicator-circle.top {
  top: -4px;
}
.bolt-list-drop-indicator-circle.bottom {
  bottom: -4px;
}

.bolt-list-drop-indicator-line {
  background-color: rgba( 199, 224, 244 ,  1 );
  background-color: rgba( var(--palette-primary-tint-20,199, 224, 244) ,  1 );
  height: 3px;
  right: 0px;
}
.bolt-list-drop-indicator-line.top {
  top: -1px;
}
.bolt-list-drop-indicator-line.bottom {
  bottom: -1px;
}
.bolt-list-drop-indicator-line.left {
  height: 100%;
  width: 3px;
}
.bolt-list-drop-indicator-line.right {
  height: 100%;
  width: 3px;
}

.bolt-list-tree-drop-target {
  border: 1px solid rgba(0, 120, 212, 1);
  border: 1px solid var(--component-grid-focus-border-color,rgba(0, 120, 212, 1));
}

/*# sourceMappingURL=ListDropIndicator.css.map */
`, "",{"version":3,"sources":["webpack://./../azure-devops-ui/src/Components/List/ListDropIndicator.scss","webpack://./../azure-devops-ui/src/Core/_platformCommon.scss","webpack://./../azure-devops-ui/bin/Components/List/ListDropIndicator.css"],"names":[],"mappings":"AACA;EACI,2CC0BoB;EDzBpB,0EAAA;EACA,kBAAA;EACA,WAAA;EEAF,UAAU;AFER;AEAJ;EACE,SAAS;AFGP;AEDJ;EACE,YAAY;AACd;;AAEA;EFII,4CAAA;EACA,2EAAA;EEFF,WAAW;EFIT,UAAA;AEFJ;AACA;EFKI,SAAA;AEHJ;AACA;EFMI,YAAA;AEJJ;AACA;EACE,YAAY;EFOV,UAAA;AELJ;AACA;EACE,YAAY;EACZ,UAAU;AFQZ;;AELA;EACE,sCAAsC;EACtC,+EAA+E;AACjF;;AAEA,gDAAgD","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
